function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
// ================================
// AIWA AJAX ADD TO CART (FINAL UX) — UPDATED (NO TIMER IN TOAST)
// - Toast stays calm: confirmation + AIWA20 reassurance only
// - Urgency moved OUT of toast: top-of-page reservation banner (minutes-only, no seconds)
// - NO flashing, NO seconds countdown, NO click blocking
// - Does NOT change cart logic / API calls / CTA hierarchy
// Target: button#ddddEnableSubmitButtonOnReady
// ================================
(function () {
  if (window.__AIWA_ATC_TOAST_FINAL__) return;
  window.__AIWA_ATC_TOAST_FINAL__ = true;
const __AIWA_RESERVE_SHOWN_KEY__ = "__aiwa_valentine_reserve_banner_shown__"; // session flag (do not show again)

  // ---------- Reservation timer (minutes-only, calm) ----------
  const __AIWA_RESERVE_KEY__ = "__aiwa_reserve_expiry_ts__";
  const __AIWA_RESERVE_DURATION__ = 15 * 60 * 1000; // 15 minutes (session-based)

  function __aiwaEnsureReserveExpiry() {
    let ts = Number(sessionStorage.getItem(__AIWA_RESERVE_KEY__) || 0);
    const now = Date.now();
    if (!ts || ts <= now) {
      ts = now + __AIWA_RESERVE_DURATION__;
      sessionStorage.setItem(__AIWA_RESERVE_KEY__, String(ts));
    }
    return ts;
  }

  function __aiwaReserveMinutesLeft() {
    const ts = Number(sessionStorage.getItem(__AIWA_RESERVE_KEY__) || 0);
    if (!ts) return null;
    const leftMs = ts - Date.now();
    return Math.max(0, Math.ceil(leftMs / 60000)); // minutes only
  }

  function ensureReserveBannerStyles() {
    if (document.getElementById("__aiwa_reserve_banner_style")) return;
    const st = document.createElement("style");
    st.id = "__aiwa_reserve_banner_style";
    st.textContent = `
      #__aiwa_reserve_banner{
        position: fixed !important;
        left: 12px !important;
        right: 12px !important;
        top: 12px !important;
        z-index: 2147483647 !important;
        pointer-events: none !important; /* never blocks clicks */
        transform: translateY(-6px);
        opacity: 0;
        transition: opacity .18s ease, transform .18s ease;
      }
      #__aiwa_reserve_banner.__show{
        opacity: 1;
        transform: translateY(0);
      }
      #__aiwa_reserve_banner .__inner{
        background: linear-gradient(180deg,#fbf4f2,#f6eeeb) !important;
        border: 1px solid rgba(163,126,88,.22) !important;
        border-radius: 14px !important;
        padding: 12px 12px !important;
        box-shadow: 0 10px 22px rgba(20,10,10,.10) !important;
        overflow: hidden !important;
        font: 13px/1.25 -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial !important;
        color: #2b2b2b !important;
      }
      #__aiwa_reserve_banner .__row{
        display:flex; gap:10px; align-items:flex-start;
      }
      #__aiwa_reserve_banner .__bar{
        width:4px; align-self:stretch; border-radius:999px;
        background: linear-gradient(180deg,#b00000,#8c0000);
        opacity:.45;
      }
      #__aiwa_reserve_banner .__title{
        font-weight: 900;
        font-size: 13px;
        line-height: 1.2;
      }
      #__aiwa_reserve_banner .__sub{
        margin-top: 4px;
        font-size: 12.5px;
        color: rgba(43,43,43,.88);
      }
      #__aiwa_reserve_banner .__meta{
        margin-left:auto;
        font-size: 11.5px;
        color: rgba(43,43,43,.65);
        white-space: nowrap;
        font-weight: 900;
      }
      @media (min-width: 990px){
        #__aiwa_reserve_banner{ left: 18px !important; right: 18px !important; top: 14px !important; }
      }
    `;
    document.head.appendChild(st);
  }

  function ensureReserveBanner() {
    ensureReserveBannerStyles();
    let b = document.getElementById("__aiwa_reserve_banner");
    if (b) return b;

    b = document.createElement("div");
    b.id = "__aiwa_reserve_banner";
    b.innerHTML = `
      <div class="__inner" role="note" aria-live="polite">
        <div class="__row">
          <div class="__bar" aria-hidden="true"></div>
          <div style="flex:1;min-width:0;">
            <div style="display:flex;gap:10px;align-items:baseline;">
              <div class="__title">⏳ Ramdan’s offer reserved for a limited time</div>
              <div class="__meta" id="__aiwa_reserve_meta"></div>
            </div>
            <div class="__sub">Complete your order soon to keep your Radaman’s discount available at checkout, Use Code: AIWA20.</div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(b);
    return b;
  }

function showReserveBannerOnce() {
  // show only once per session
  if (sessionStorage.getItem(__AIWA_RESERVE_SHOWN_KEY__) === "1") return;

  sessionStorage.setItem(__AIWA_RESERVE_SHOWN_KEY__, "1");

  const b = ensureReserveBanner();

  const m = __aiwaReserveMinutesLeft();
  const meta = b.querySelector("#__aiwa_reserve_meta");
  if (meta) meta.textContent = (m && m > 0) ? `~${m} min` : "";

  requestAnimationFrame(() => b.classList.add("__show"));

  clearTimeout(window.__AIWA_RESERVE_HIDE_T__);
  window.__AIWA_RESERVE_HIDE_T__ = setTimeout(() => {
    b.classList.remove("__show");
  }, 5000); // ~5 seconds (per requirement)
}

  // ---------- Utils ----------
  function isActuallyVisible(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    const cs = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.display !== "none" && cs.visibility !== "hidden" && cs.opacity !== "0";
  }

  function getVisibleCartIcon() {
    const all = Array.from(document.querySelectorAll("#cart-icon-bubble"));
    return all.find(isActuallyVisible) || document.getElementById("cart-icon-bubble");
  }

  function getActiveCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.currency)) ||
      document.documentElement.getAttribute("data-currency") ||
      "AED"
    );
  }

  function formatMoneyFromCents(cents) {
    const currency = getActiveCurrency();
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amount);
    } catch (e) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  }

  // ---------- Bubble ----------
  function setBubbleCount(count) {
    const a = getVisibleCartIcon();
    if (!a) return;

    let bubble = a.querySelector(".cart-count-bubble");

    if (!count || count <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      a.appendChild(bubble);
    }

    bubble.innerHTML = `
      ${count < 100 ? `<span aria-hidden="true">${count}</span>` : ``}
      <span class="visually-hidden">${count} items</span>
    `;
  }

  function ensureAiwa20Styles() {
    if (document.getElementById("__aiwa_aiwa20_style")) return;

    const st = document.createElement("style");
    st.id = "__aiwa_aiwa20_style";
    st.textContent = `
      #__aiwa_toast #__aiwa_aiwa20_block{
        background: linear-gradient(180deg, #fbf4f2, #f6eeeb) !important;
        border: 1px solid rgba(163,126,88,.25) !important;
        box-shadow: 0 12px 26px rgba(20,10,10,.12) !important;
        border-radius: 14px !important;
        padding: 10px 12px !important;
        margin: 10px 0 !important;
        position: relative !important;
        overflow: hidden !important;
        opacity: 1 !important;
        pointer-events: none !important; /* never blocks clicks */
      }
      #__aiwa_toast #__aiwa_aiwa20_block::before{
        content:"" !important;
        position:absolute !important;
        left:0 !important; top:0 !important; bottom:0 !important;
        width:4px !important;
        background: linear-gradient(180deg, #b00000, #8c0000) !important;
        opacity:.6 !important;
        border-radius: 14px 0 0 14px !important;
        pointer-events:none !important;
      }
      #__aiwa_toast #__aiwa_aiwa20_block *{ position: relative !important; }
      #__aiwa_toast #__aiwa_aiwa20_block .aiwa20-title{
        font-weight: 900;
        font-size: 13px;
        color: #2b2b2b;
        line-height: 1.2;
      }
      #__aiwa_toast #__aiwa_aiwa20_block .aiwa20-body{
        margin-top: 4px;
        font-size: 12.5px;
        color: #2b2b2b;
        line-height: 1.25;
      }
      #__aiwa_toast #__aiwa_aiwa20_block .aiwa20-code{
        font-weight: 900;
        padding: 1px 6px;
        border-radius: 999px;
        background: rgba(163,126,88,.14) !important;
        color:#6b3f2a !important;
        letter-spacing: .4px;
      }
      #__aiwa_toast #__aiwa_aiwa20_block .aiwa20-help{
        margin-top: 3px;
        font-size: 11.5px;
        color: rgba(43,43,43,.78);
        line-height: 1.2;
      }
    `;
    document.head.appendChild(st);
  }

  // ---------- Toast ----------
  function ensureToastBox() {
    let box = document.getElementById("__aiwa_toast");
    if (box) return box;

    box = document.createElement("div");
    box.id = "__aiwa_toast";
    box.style.cssText =
      "position:fixed;right:14px;bottom:90px;z-index:2147483647;" +
      "max-width:360px;background:#f6f1ea;color:#2b2b2b;padding:14px 14px;" +
      "border-radius:14px;border:1px solid rgba(0,0,0,.08);" +
      "box-shadow:0 14px 32px rgba(0,0,0,.18);" +
      "font: 14px/1.35 -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial;" +
      "opacity:0;transform:translateY(10px);transition:opacity .15s, transform .15s;";

    document.body.appendChild(box);
    return box;
  }

  function hideToast() {
    const box = document.getElementById("__aiwa_toast");
    if (!box) return;

    // IMPORTANT: stop capturing clicks immediately
    box.style.pointerEvents = "none";
    box.style.opacity = "0";
    box.style.transform = "translateY(10px)";

    setTimeout(() => {
      if (!box) return;
      box.style.display = "none";
    }, 180);
  }

  function toastFinal(opts) {
    const box = ensureToastBox();
    box.style.display = "block";
    box.style.pointerEvents = "auto";
    ensureAiwa20Styles();

    const title = opts && opts.title ? String(opts.title) : "";
    const itemCount = opts && typeof opts.item_count === "number" ? opts.item_count : 0;
    const subtotal = opts && typeof opts.total_price !== "undefined" ? formatMoneyFromCents(opts.total_price) : formatMoneyFromCents(0);

    box.innerHTML = `
      <div style="position:relative">
        <button type="button" aria-label="Close"
          id="__aiwa_toast_close"
          style="position:absolute;top:0;right:0;border:0;background:transparent;color:#2b2b2b;
                 font-size:22px;line-height:1;cursor:pointer;opacity:.9;padding:0;margin:0;z-index:999999">
          ×
        </button>

        <div style="font-weight:900;font-size:15px;padding-right:22px">🛒 Your cart</div>

        ${title ? `<div style="opacity:.92;margin-top:6px;font-size:13px;word-break:break-word">${title}</div>` : ``}

        <div style="margin-top:8px;font-size:13px;opacity:.92">
          <span><b>${itemCount}</b> item${itemCount === 1 ? "" : "s"}</span>
          <span style="opacity:.55"> • </span>
          <span>Subtotal: <b>${subtotal}</b></span>
        </div>

        <div id="__aiwa_toast_ctas_wrap" style="display:grid;gap:10px;margin-top:12px;">
          <button type="button" id="__aiwa_instant"
            style="display:block;width:100%;text-align:center;padding:12px 14px;border-radius:12px;
                   border:0;cursor:pointer;background:linear-gradient(90deg,#b00000,#8c0000);
                   color:#fff;font-weight:900;letter-spacing:.2px;font-size:15px;
                   box-shadow:0 12px 26px rgba(176,0,0,.35);">
            ⚡ Instant Checkout
            <span style="display:block;font-size:12px;font-weight:700;opacity:.9;margin-top:2px;color:#fff">
              Same-day / Immediate delivery
            </span>
          </button>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            <a href="/cart"
              style="display:block;width:100%;text-align:center;padding:12px 14px;border-radius:12px;
                     background:#2b2b2b;color:#fff;font-weight:900;letter-spacing:.2px;font-size:14px;
                     text-decoration:none;border:1px solid rgba(0,0,0,.12);">
              Go to cart
            </a>

            <button type="button" id="__aiwa_continue"
              style="display:block;width:100%;text-align:center;padding:12px 14px;border-radius:12px;
                     border:1px solid rgba(0,0,0,.12);background:rgba(0,0,0,.04);color:#2b2b2b;
                     font-weight:900;letter-spacing:.2px;font-size:14px;cursor:pointer;">
              Continue shopping
            </button>
          </div>

          <div style="opacity:.78;margin-top:0px;font-size:12px;color:#2b2b2b">
            Instant Checkout skips cart steps — including gift card messages, notes, and delivery date selection — for the fastest ordering.
          </div>
        </div>
      </div>
    `;

    // show (NO auto-hide)
    requestAnimationFrame(() => {
      box.style.opacity = "1";
      box.style.transform = "translateY(0)";
    });

    const closeBtn = box.querySelector("#__aiwa_toast_close");
    if (closeBtn) closeBtn.onclick = hideToast;

    const contBtn = box.querySelector("#__aiwa_continue");
    if (contBtn) contBtn.onclick = hideToast;

    const instantBtn = box.querySelector("#__aiwa_instant");
    if (instantBtn) {
      instantBtn.onclick = async () => {
        try {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: { delivery_speed: "Same-day / Immediate (from toast)" } }),
          });
        } catch (e) {}
        window.location.href = "/checkout";
      };
    }
  }

  async function fetchCartSafe() {
    try {
      const cartRes = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!cartRes.ok) throw new Error("cart.js failed");
      return await cartRes.json();
    } catch (e) {
      return null;
    }
  }

  async function openCartToast(extraTitle) {
    const cart = await fetchCartSafe();
    toastFinal({
      title: extraTitle || "",
      item_count: cart ? cart.item_count : 0,
      total_price: cart ? cart.total_price : 0,
    });
  }

  // ---------- Validation (optional) ----------
  function validateRequiredFields(form) {
    return true;
  }

  // ---------- Add to cart handler ----------
  document.addEventListener(
    "submit",
    async function (e) {
      const submitter = e.submitter;
      if (!submitter || submitter.id !== "ddddEnableSubmitButtonOnReady") return;

      const form = submitter.closest('form[action^="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (!validateRequiredFields(form)) return;

      try {
        submitter.disabled = true;

        // Start/refresh reservation window on add-to-cart (logic only, not shown in toast)
        // Start reservation window only once per session (do not reset on later ATCs)
        if (!sessionStorage.getItem(__AIWA_RESERVE_KEY__)) __aiwaEnsureReserveExpiry();

        // Show banner only once per session
        showReserveBannerOnce();
        const fd = new FormData(form);

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: fd,
        });

        if (!res.ok) throw new Error(await res.text());
        const added = await res.json();

        const cart = await fetchCartSafe();
        if (cart) setBubbleCount(cart.item_count);

        toastFinal({
          title: `Added: ${added.product_title || added.title || ""}`,
          item_count: cart ? cart.item_count : 0,
          total_price: cart ? cart.total_price : 0,
        });
      } catch (err) {
        //console.error("AIWA AJAX add failed:", err);
        toastFinal({ title: "Add to cart failed", item_count: 0, total_price: 0 });
      } finally {
        submitter.disabled = false;
      }
    },
    true
  );
  document.addEventListener('aiwa:upsell-added', async function (e) {
  const cart = await fetchCartSafe();
  if (cart) setBubbleCount(cart.item_count);

  toastFinal({
    title: `Added: ${e.detail && e.detail.title ? e.detail.title : ''}`,
    item_count: cart ? cart.item_count : 0,
    total_price: cart ? cart.total_price : 0,
  });
});
})();

/* ==================================================
   AIWA – Ramadan Menu Bar Injection
   File: global.js
   Purpose:
   - Injects Ramadan promotion bar
   - Appears at top of mobile menu drawer
   - Links to Ramadan collection
   ================================================== */
/* DEACTIVATED - Mother's Day Bar

document.addEventListener('DOMContentLoaded', () => {
  const drawer =
    document.querySelector('menu-drawer .menu-drawer') ||
    document.querySelector('.menu-drawer');

  if (!drawer) return;

  // Prevent duplicate injection
  if (drawer.querySelector('#aiwa-hamburger-bar')) return;

  const bar = document.createElement('a');
  bar.id = 'aiwa-hamburger-bar';
  bar.href = 'https://www.aiwaflowers.ae/collections/mothers-day-flowers';
  bar.className = 'aiwa-banner-link';
  bar.setAttribute('aria-label', 'Ramadan Flowers Collection');

  bar.innerHTML = `
    <span class="aiwa-r-title">Mother's Day Collection</span>
    <span class="aiwa-r-sub">Shop now →</span>
  `;

  drawer.prepend(bar);
});
DEACTIVATED */

/* AIWA — Add product context (image + title + price) above existing sticky ATC button (mobile only) */
(function () {
  const isProductPage = () =>
    location.pathname.includes("/products/") &&
    !!document.querySelector('form[action^="/cart/add"]');

  const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

  const getATCButton = () =>
    document.querySelector(
      '.product__info-container form[action^="/cart/add"] button.product-form__submit[name="add"],' +
      '.product__info-container button.product-form__submit[name="add"]'
    );

  const getTitleEl = () => document.querySelector("h1.product__title");

  const getPriceText = () => {
    const sale = document.querySelector(".price-item--sale")?.textContent?.trim();
    const reg  = document.querySelector(".price-item--regular")?.textContent?.trim();
    return (sale || reg || "").trim();
  };

  const getImageSrc = () => {
    const img =
      document.querySelector(".product__media img") ||
      document.querySelector('img[src*="cdn.shopify.com"]');
    return img?.currentSrc || img?.src || "";
  };

  const buildStrip = () => {
    // remove old if any
    document.getElementById("aiwa-sticky-info-strip")?.remove();

    const strip = document.createElement("div");
    strip.id = "aiwa-sticky-info-strip";
    strip.className = "aiwa-sticky-info-strip";
    strip.setAttribute("aria-hidden", "true");

    document.body.appendChild(strip);
    return strip;
  };

  const renderStrip = (strip) => {
    const title = getTitleEl()?.textContent?.trim() || "Product";
    const price = getPriceText();
    const imgSrc = getImageSrc();

    strip.innerHTML = `
      <div class="aiwa-sticky-info-strip__row">
        ${imgSrc ? `<img class="aiwa-sticky-info-strip__img" src="${imgSrc}" alt="">` : ""}
        <div class="aiwa-sticky-info-strip__text">
          <div class="aiwa-sticky-info-strip__hint">You’re adding</div>
          <div class="aiwa-sticky-info-strip__title">${title}</div>
        </div>
        <div class="aiwa-sticky-info-strip__price">${price}</div>
      </div>
    `;
  };

  const init = () => {
    if (!isProductPage()) return;

    const atcBtn = getATCButton();
    const titleEl = getTitleEl();
    if (!atcBtn || !titleEl) return;

    // Only useful if your ATC is actually fixed (your existing CSS does this on mobile)
    if (!isMobile()) return;

    const strip = buildStrip();
    renderStrip(strip);

    let ticking = false;
    let visible = false;

    const updateVisibility = () => {
      const r = titleEl.getBoundingClientRect();
      const shouldShow = r.bottom < 0 && isMobile();

      if (shouldShow && !visible) {
        strip.classList.add("is-visible");
        strip.setAttribute("aria-hidden", "false");
        visible = true;
      } else if (!shouldShow && visible) {
        strip.classList.remove("is-visible");
        strip.setAttribute("aria-hidden", "true");
        visible = false;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });

    // Keep price/image updated when variant changes (works broadly)
    document.addEventListener("change", (e) => {
      if (!isProductPage()) return;
      // if variant selectors change, re-render
      if (e.target && (e.target.name === "id" || e.target.closest("variant-selects") || e.target.closest("product-form"))) {
        setTimeout(() => renderStrip(strip), 50);
      }
    });

    // Also re-render if price DOM changes (sale/regular updates)
    const priceRoot = document.querySelector(".price");
    if (priceRoot) {
      const mo = new MutationObserver(() => renderStrip(strip));
      mo.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    // first run
    updateVisibility();
  };

  // run after DOM ready
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
  
/* AIWA PRODUCT GALLERY DOTS */

document.addEventListener("DOMContentLoaded", function(){

const dots = document.querySelectorAll(".aiwa-dot");
const slides = document.querySelectorAll(".product__media-item");
const slider = document.querySelector(".product__media-list");

if(!dots.length || !slides.length || !slider) return;

dots.forEach((dot,i)=>{

  dot.addEventListener("click",()=>{

    slides[i].scrollIntoView({
      behavior:"smooth",
      inline:"center"
    });

    dots.forEach(d=>d.classList.remove("active"));
    dot.classList.add("active");

  });

});

slider.addEventListener("scroll",()=>{

  let closest = 0;
  let minOffset = Infinity;

  slides.forEach((slide,i)=>{
    const rect = slide.getBoundingClientRect();
    const offset = Math.abs(rect.left);

    if(offset < minOffset){
      minOffset = offset;
      closest = i;
    }
  });

  dots.forEach(d=>d.classList.remove("active"));
  if(dots[closest]) dots[closest].classList.add("active");

});

});